// extracted by mini-css-extract-plugin
export var errorsContainer = "_rs-1";
export var link = "_rs-0";